import Request from './request'

const Device_Rpc = {
  getRPCTemplate (id, callback, bad_answer) {
    Request.get('device-rpc/template/' + id).then(callback).catch(bad_answer || this.bad_answer)
  },
  updateRPCTemplate (id, params, callback, bad_answer) {
    Request.put('device-rpc/template/' + id, JSON.stringify(params)).then(callback).catch(bad_answer || this.bad_answer)
  },
  getRPCInfo (fid, callback) {
    Request.get('device-rpc/index/' + fid).then(callback).catch(this.bad_answer)
  },
  runRPCCommand (id, params, callback) {
    Request.post('device-rpc/run/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  checkRPCCommand (id, callback) {
    Request.get('device-rpc/get-cmd/' + id).then(callback).catch(this.bad_answer)
  }
}
export default Device_Rpc
